module.exports = __webpack_public_path__ + "img/filter_icon_1.73af7082.webp";